export default __webpack_public_path__ + "static/media/checked_mobile.09dac257.svg";